import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { BaseAdmin, AdministratorUserApiModel } from '../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealIds: builder.query<{ id: string }[], string>({
      query: (accountId) => `v4/accounts/${accountId}/succinct-deals`,
      providesTags: ['Deal'],
    }),
    inviteAdmin: builder.mutation<
      AdministratorUserApiModel,
      { accountId: string; data: BaseAdmin }
    >({
      query: ({ accountId, data }) => ({
        url: `v4/accounts/${accountId}/admins`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Admin'],
    }),
    updateAdmin: builder.mutation<
      AdministratorUserApiModel,
      { accountId: string; data: BaseAdmin }
    >({
      query: ({ accountId, data }) => ({
        url: `v4/accounts/${accountId}/admins`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const {
  useGetDealIdsQuery,
  useInviteAdminMutation,
  useUpdateAdminMutation,
} = apiSlice;
